module.exports = __webpack_public_path__ + "static/bot3-7ead1ac77cbdd02785b0a246799f5548.jpg";